import { render } from "./TruckoIcon.vue?vue&type=template&id=2cb15fa3"
import script from "./TruckoIcon.vue?vue&type=script&lang=js"
export * from "./TruckoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__